import { Crosshair, Zap, Trophy, Target } from "lucide-react";

const stats = [
  { kpi: "12", label: "On the Roster", Icon: Crosshair },
  { kpi: "5\u20131", label: "Season Record", Icon: Trophy },
  { kpi: "100%", label: "Heart Rate", Icon: Zap },
  { kpi: "0", label: "Quitters", Icon: Target },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-[#0a0a0a] border-y border-neutral-900"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 md:py-16 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-8">
        {stats.map(({ kpi, label, Icon }, i) => (
          <div
            key={i}
            className="reveal flex flex-col gap-3 border-l border-neutral-800 pl-5"
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <Icon size={20} className="text-[#e11d2a]" />
            <div className="font-anton text-5xl md:text-6xl text-white leading-none tracking-tighter">
              {kpi}
            </div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 font-bold">
              {label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
